export default {
    baseUrl: 'https://graph.microsoft.com/v1.0',
    scopes: ['user.read']
}